var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNoPayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VenueNext_Small_Icons_V2-08",
    clipPath: "url(#clip0_12441_282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.6517 24H3.34832C1.50562 24 0 22.6568 0 21.0129V5.98711C0 4.3432 1.50562 3 3.34832 3H28.6517C30.4944 3 32 4.3432 32 5.98711V21.0129C32 22.6568 30.4944 24 28.6517 24ZM3.34832 4.46348C2.40449 4.46348 1.64045 5.14511 1.64045 5.98711V21.0129C1.64045 21.8549 2.40449 22.5365 3.34832 22.5365H28.6517C29.5955 22.5365 30.3596 21.8549 30.3596 21.0129V5.98711C30.3596 5.14511 29.5955 4.46348 28.6517 4.46348H3.34832Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.38008 13.4301V14.3701H7.66008V13.4101C6.48008 13.2401 5.72008 12.4001 5.73008 11.4101H6.99008C6.99008 11.9501 7.42008 12.3901 8.14008 12.3901C8.79008 12.3901 9.16008 12.0001 9.16008 11.5301C9.16008 11.1601 8.91008 10.8601 8.28008 10.6901L7.47008 10.4601C6.03008 10.0901 5.78008 9.23011 5.78008 8.67011C5.78008 7.65011 6.60008 6.91011 7.66008 6.77011V5.86011H8.38008V6.77011C9.49008 6.90011 10.2501 7.67011 10.2401 8.75011H8.97008C8.98008 8.21011 8.60008 7.83011 8.03008 7.83011C7.46008 7.83011 7.06008 8.18011 7.06008 8.64011C7.06008 8.83011 7.11008 9.20011 7.82008 9.39011L8.59008 9.59011C9.65008 9.87011 10.4401 10.4501 10.4401 11.4701C10.4401 12.5901 9.55008 13.3401 8.38008 13.4401V13.4301Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.2399 16.38C26.5588 16.38 30.0599 12.8789 30.0599 8.55999C30.0599 4.24112 26.5588 0.73999 22.2399 0.73999C17.9211 0.73999 14.4199 4.24112 14.4199 8.55999C14.4199 12.8789 17.9211 16.38 22.2399 16.38Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.2399 17.11C17.5199 17.11 13.6799 13.27 13.6799 8.55C13.6799 3.83 17.5199 0 22.2399 0C26.9599 0 30.7999 3.84 30.7999 8.56C30.7999 13.28 26.9599 17.12 22.2399 17.12V17.11ZM22.2399 1.46C18.3299 1.46 15.1499 4.64 15.1499 8.55C15.1499 12.46 18.3299 15.64 22.2399 15.64C26.1499 15.64 29.3299 12.46 29.3299 8.55C29.3299 4.64 26.1499 1.46 22.2399 1.46Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24.95 12.3001L18.49 5.84006L19.53 4.81006L25.99 11.2701L24.95 12.3001Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M19.53 12.3001L18.49 11.2701L24.95 4.81006L25.99 5.84006L19.53 12.3001Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13.9401 16.1001H5.57007V17.5601H13.9401V16.1001Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M5.57007 19.75H17.9801",
    stroke: "#1D2939",
    strokeWidth: 1.46,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12441_282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoPayment);
export default __webpack_public_path__ + "static/media/IconNoPayment.0b71ceaa.svg";
export { ForwardRef as ReactComponent };